/* eslint-disable */

import { bus } from '@/main'
import commonSocket from '@/commonSocket'

export default {
  data() {
    return {
      socketHandlers: [],
      selfUserId: ''
    }
  },
  methods: {
    // ---------------- INITIALIZATION ----------------
    initSocketLifecycle(userId) {
      this.selfUserId = userId || localStorage.getItem('LoginedUserID')

      // Do not open dashboard socket if inside video pages
      if (['videoConferenceMain', 'videoCallOneToOnePeer'].includes(this.$route.name)) return

      this.$nextTick(() => {
        this.connectCommonSocket()
      })
    },

    // ---------------- CONNECT & BIND ----------------
    connectCommonSocket() {
      const callerID = '3548d149becb44e9'
      commonSocket.connect(callerID)

      // Bind basic connection configuration
      this.onSocket('connection', () => {
        commonSocket.emit({
          type: 'userStatus',
          userID: this.selfUserId
        })
      })

      // Register structural socket handlers map
      this.onSocket('userLogin', this.handleUserLogin)
      this.onSocket('userStatus', this.handleSelfUserStatus)
      this.onSocket('selfUserStatus', this.handleAllUserStatus)
      this.onSocket('TypingEventForSelectedUserNotification', this.handleTypingEventNotification)
      this.onSocket('videoCallingNotification', this.handleVideoCall)
      this.onSocket('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs)
      this.onSocket('friendRequest', this.handleFriendRequest)
      this.onSocket('newMessageNotifications', this.handleNewMessageNotification)
      this.onSocket('messageForwardedOfUsersNotification', this.handleMessageForwarded)
      this.onSocket('userLogout', this.handleUserLogout)
    },

    // Track listeners safely to avoid memory leaks
    onSocket(event, handler) {
      if (!this.socketHandlers) {
        this.socketHandlers = []
      }
      commonSocket.$on(event, handler)
      this.socketHandlers.push({ event, handler })
    },

    // ---------------- CLEANUP METHODS ----------------
    offAllSocket() {
      if (this.socketHandlers && this.socketHandlers.length) {
        this.socketHandlers.forEach(({ event, handler }) => {
          commonSocket.$off && commonSocket.$off(event, handler)
        })
      }
      this.socketHandlers = []
    },

    closeSocket() {
      this.offAllSocket()
      if (commonSocket.isOpen && commonSocket.isOpen()) {
        commonSocket.close()
      }
    },

    // ---------------- DEFAULT HANDLERS ----------------
    handleVideoCall(data) {
      if (this.selfUserId !== data.targetId) return
      if (typeof this.showCallingPushNotification === 'function') {
        this.showCallingPushNotification(data)
      }
      document.body.classList.add('videoNotificationPopup')
      this.callerInfo = data
      this.roomId = data.roomId
      this.incomingCallNotification = true
    },

    callerPopupClosedInOtherTabs(payload) {
      if (this.selfUserId !== payload.videoCallRoomId) return
      if (payload.type === 'videoAlertPopupClose') {
        if (typeof this.stopSound === 'function') this.stopSound()
        document.body.classList.remove('videoNotificationPopup')
        this.callerInfo = null
        this.incomingCallNotification = false
      }
    },

    handleNewMessageNotification(res) {
      bus.$emit('messagesNotificationCount', res)
      bus.$emit('updateMessageNotifications', res)
    },

    handleMessageForwarded(res) {
      if (res.toUserID === this.selfUserId) return
      bus.$emit('forwardedMessageNotifications', res)
    },

    handleFriendRequest(res) {
      if (res.fromUserID === this.selfUserId || res.userID !== this.selfUserId) return
      bus.$emit('userFriendRequest', { userID: res.userID })
    },

    handleUserLogin(res) {
      const payload = {
        userID: res.userID,
        is_online: true,
        device_type: res.device,
        current_status: res.status
      }

      bus.$emit('userUpdateStatus', payload)

      if (payload.userID === this.selfUserId) {
        this.$store.commit('UPDATE_SELF_USER_STATUS', payload)
      }
    },

    handleUserLogout(res) {
      const payload = {
        userID: res.userID,
        is_online: !res.browser_logout
      }

      bus.$emit('userUpdateStatus', payload)

      if (payload.userID === this.selfUserId) {
        this.$store.commit('UPDATE_SELF_USER_STATUS', payload)
      }
    },

    handleSelfUserStatus(res) {
      bus.$emit('selfUserUpdateStatus', res)
    },

    handleAllUserStatus(res) {
      if (res.userID === this.selfUserId) {
        const payload = {
          is_online: true,
          current_status: res.current_status
        }
        this.$store.commit('UPDATE_SELF_USER_STATUS', payload)
      } {
        bus.$emit('userSelfStatus', res)
      }
    },

    handleTypingEventNotification(res) {
      bus.$emit('typingEventForChatBus', res)
    }
  }
}